import React from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import ContentSections from 'components/base/ContentSections';
import { SaveAndBackButtons } from 'components/base/BottomStepComponent';

import './CreateLevelDiscountContent.scss';
import { APIStatus } from 'config/CustomEnums';
import Loading from 'components/base/Loading';
import EntryRequirementSection from 'components/level/EntryRequirementSection';
import RenewalAndDowngradeSection from 'components/level/RenewalAndDowngradeSection';
import { createLevelStepTwoValidate } from './CreateLevelValidate';


const CreateLevelStepTwo = ({
  createLevelStatus,
  levelList,
  levelGlobalSetting,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const levelId = params.id;

  const { getValues, setError, clearErrors } = useFormContext();

  const changeStep = (isBack) => {
    if (isBack) {
      dispatch({
        type: 'levels/stepChange',
        payload: { isBack: true, step: 1, isValid: true },
      });
      return;
    }

    const isValid = createLevelStepTwoValidate({
      getValues,
      setError,
      clearErrors,
      levelList,
      levelGlobalSetting,
    });
    if (isValid) {
      dispatch({
        type: 'levels/createOrUpdateLevel',
        payload: {
          data: getValues(),
          afterAction: () => history.push({ pathname: '/levels' }),
        },
      });
    };
  };

  if (createLevelStatus === APIStatus.calling) {
    return <Loading />
  };

  return (
    <>
      <ContentSections
        sections={[
          <EntryRequirementSection />,
          <RenewalAndDowngradeSection />,
        ]}
        hidePreview
      />
      <SaveAndBackButtons
        backAction={() => {
          changeStep(true);
        }}
        saveText={levelId ? 'Update' : 'Save'}
        saveAction={() => {
          changeStep(false);
        }}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  createLevelStatus: state.levels.createLevelStatus,
  levelList: state.levels?.pagedList,
  levelGlobalSetting: state.levels.levelGlobalSetting,
})

export default connect(mapPropsToState)(CreateLevelStepTwo);
